import React, {PureComponent} from "react"

import withBranding, {WithBranding} from "@irati/brand/withBranding"
import defaultAuth from "@irati/auth/helpers/defaultAuth"
import {H3} from "@irati/ui/src/Headings"
import {Para} from "@irati/ui/src/Labels"
import Button from "@irati/ui/src/Button"
import {FormattedMessage} from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"
import PlaceholderBar, {PlaceholderContainer, PlaceholderGrid, PlaceholderSquare} from "@irati/ui/src/Placeholder"
import {HeaderBar, MockPBLogo, DottedLogo, DottedBrandLine, LogoText, BrandLine} from "./styled"

export enum PreviewVariants {
  Default = "Default",
  Unset = "Unset",
  Custom = "Custom"
}

interface Props extends WithBranding {
  variant: PreviewVariants,
  handleClick?: () => void,
  forceColor?: string
}

class BrandPreview extends PureComponent<Props> {
  getLinkAndColor = () => {
    const {variant, branding} = this.props
    if (variant === PreviewVariants.Default) {
      const {imageLink, color} = defaultAuth.userTenant.settings
      return {imageLink, color}
    } else {
      const {businessLogoUrl: imageLink, textColour: color} = branding
      return {imageLink, color}
    }
  }

  render() {
    const {variant, handleClick, forceColor, branding} = this.props
    const PBLogoLink = branding.businessLogoUrl

    const isUnset = variant === PreviewVariants.Unset
    const isCustom = variant === PreviewVariants.Custom

    const {imageLink, color} = this.getLinkAndColor()

    return (
      <>
        <Flex alignItems="center" justifyContent="space-between" height="60px">
          <H3>
            <FormattedMessage id="setup_tenant.steps.brand.brandPreview.title" />
          </H3>
          {isUnset && (
            <Button primary onClick={handleClick}>
              <FormattedMessage id="setup_tenant.steps.brand.brandPreview.setBrandButton" />
            </Button>
          )}
          {isCustom && (
            <Button primary onClick={handleClick}>
              <FormattedMessage id="setup_tenant.steps.brand.brandPreview.updateBrandButton" />
            </Button>
          )}
        </Flex>
        <Para>
          <FormattedMessage id="setup_tenant.steps.brand.brandPreview.text" />
        </Para>
        <PlaceholderContainer>
          <HeaderBar>
            <MockPBLogo src={PBLogoLink} />
            {!isUnset && <MockPBLogo src={imageLink} />}
            {isUnset && (
              <DottedLogo>
                <LogoText>
                  <FormattedMessage id="setup_tenant.steps.brand.brandPreview.logoText" />
                </LogoText>
              </DottedLogo>
            )}
          </HeaderBar>
          {isUnset && <DottedBrandLine />}
          {!isUnset && <BrandLine brandColor={forceColor || color} isMobile={false} />}
          <PlaceholderContainer border="none" padding="30px">
            <PlaceholderBar type="dark" margin="0 0 30px 0" width="20%" />
            <PlaceholderBar margin="30px 0" width="10%" />
            <PlaceholderGrid rows={1} columns={3} />
            <PlaceholderSquare margin="15px 0 0 0" />
          </PlaceholderContainer>
        </PlaceholderContainer>
      </>
    )
  }
}

export default withBranding(BrandPreview)
